import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { setWorkspaceType } from 'app/store/ui/uiSlice';
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';
// Selectors
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectNewDesignEnabled } from 'app/store/pagesToolbar/pagesToolbar.selectors';
import { selectWorkspaceType } from 'app/store/ui/uiSelectors';
// Mui
import { IconButton, Theme, ToggleButton, ToggleButtonGroup } from '@mui/material';
// Icons
import {
  ArrowDropDown as ArrowDropDownIcon
} from '@mui/icons-material';
// Components
import Icon from 'app/components/Icon';
// Hooks
import useMenu from 'app/hooks/useMenu';
// Mixpanel
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';

const WorkspaceViewModeGroup = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // Selectors
  const trialMode = useAppSelector(selectTrialMode);
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);
  // ToDO
  const workspaceType = useAppSelector(selectWorkspaceType);

  const { Menu, MenuItem, openMenu } = useMenu();

  const handleChange = (_:any, value:string | null) => {
    if ( !value ) return;
    dispatch(setWorkspaceType(value as any));
    dispatch(PagesToolbarActions.clearSelectedPages());
    if ( value === 'pages' ) {
      dispatch(MixpanelActions.handleCaseWorkspaceSwitchToPagesViewClick());
    } else {
      dispatch(MixpanelActions.handleCaseWorkspaceSwitchToEpisodeViewClick());
    }
  }

  if ( trialMode ) return null;
  if ( newDesignEnabled ) return (
    <Fragment>
      <IconButton
        name="Workspace view mode"
        sx={{
          border: (theme:Theme) => `1px solid ${theme.palette.divider}`,
          height: 40,
        }}
        onClick={openMenu}
      >
        <Icon icon={workspaceType === 'pages' ? 'pages_view' : 'episodes_view'} />
        <ArrowDropDownIcon fontSize="small" />
      </IconButton>
      <Menu>
        <MenuItem
          name="Pages view"
          sx={{ gap: 2, textTransform: 'capitalize' }}
          onClick={() => handleChange(null, 'pages')}
          selected={workspaceType === 'pages'}
        >
          <Icon icon="pages_view" />
          {t('pages.workspace.pagesView')}
        </MenuItem>
        <MenuItem
          name="Episodes view"
          sx={{ gap: 2, textTransform: 'capitalize' }}
          onClick={() => handleChange(null, 'episodes')}
          selected={workspaceType === 'episodes'}
        >
          <Icon icon="episodes_view" />
          {t('pages.workspace.episodesView')}
        </MenuItem>
      </Menu>
    </Fragment>
  );
  return (
    <ToggleButtonGroup
      value={workspaceType}
      onChange={handleChange}
      color="primary"
      exclusive
      fullWidth={true}
      size="small"
    >
      <ToggleButton sx={{
        borderColor: (theme:Theme) => theme.palette.primary.main,
        gap: 2
      }} value="pages">
        {t('pages.workspace.pagesView')}
      </ToggleButton>
      <ToggleButton sx={{
        borderColor: (theme:Theme) => theme.palette.primary.main,
        gap: 2
      }} value="episodes">
        {t('pages.workspace.episodesView')}
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default WorkspaceViewModeGroup;
